import { Button, Group } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { MerchantOnboardingStatus } from '../../../enums/merchant-onboarding-status';
import { OpenComponent } from '../../../enums/misc.enum';
import { disable, enable } from '../../../helpers/onboarding-status';
import { BasicMerchant } from '../../../type/admin.types';
import DisabledModal from '../../admin-entities/admin-entity-manager/components/disabled-modal.component';
interface UpdateDisableButtonProps {
  isChecked: number[];
  merchants: BasicMerchant[] | undefined;
  setRefreshTable: React.Dispatch<React.SetStateAction<boolean>>;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
}

function UpdateDisableButton(props: UpdateDisableButtonProps) {
  const { isChecked, merchants, setRefreshTable, setComponentManager } = props;
  const [isDisabledModalOpen, setisDisabledModalOpen] = useState(false);

  const getEntityName = (): string => {
    let name = 'item';

    if (merchants) {
      if (isChecked?.length > 1) {
        name = 'onboarding';
      } else if (isChecked?.length === 1) {
        const selectedMerchant = merchants.find(
          (merchants) => merchants.merchantId === isChecked[0]
        );
        name = selectedMerchant?.merchantName ?? 'onboarding';
      }
    }

    return name;
  };

  const [disableD, setDisableD] = useState(false);
  const [disableU, setDisableU] = useState(false);
  const [disableE, setDisableE] = useState(false);

  const [isLoadingD, setIsLoadingD] = useState(false);
  const [isLoadingE, setIsLoadingE] = useState(false);

  const update = (id: number) => {
    setComponentManager(OpenComponent.UPDATE_USER);
  };

  const handleDisable = async (disabledReason: string) => {
    // setIsLoading(true);
    setIsLoadingD(true);

    try {
      await disable(isChecked, disabledReason);
      setRefreshTable((prev) => !prev);
    } catch (err: any) {
    } finally {
      // setIsLoading(false);
      setIsLoadingD(false);
    }
  };

  const handleEnable = async () => {
    // setIsLoading(true);
    setIsLoadingE(true);

    try {
      await enable(isChecked);
      setRefreshTable((prev) => !prev);
    } catch (err: any) {
    } finally {
      // setIsLoading(false);
      setIsLoadingE(false);
    }
  };

  useEffect(() => {
    setDisableU(false);
    setDisableD(false);
    setDisableE(false);

    if (!merchants) {
      setDisableU(true);
      setDisableD(true);
      setDisableE(true);
      return;
    }

    if (isChecked.length === 0) {
      setDisableU(true);
      setDisableD(true);
      setDisableE(true);
    } else if (isChecked.length > 1) {
      setDisableU(true);
    }

    merchants.forEach((merchant) => {
      if (isChecked.includes(merchant.merchantId)) {
        if (merchant.isActive) {
          setDisableE(true);
          if (merchant.onboardingStatus !== MerchantOnboardingStatus.APPROVED) {
            setDisableU(true);
          }

          if (
            merchant.onboardingStatus === MerchantOnboardingStatus.DECLINED ||
            merchant.onboardingStatus === MerchantOnboardingStatus.NEW ||
            merchant.onboardingStatus === MerchantOnboardingStatus.PENDING
          ) {
            setDisableD(true);
          }
        } else {
          setDisableU(true);
          setDisableD(true);
        }
      }
    });
  }, [isChecked, merchants]);

  return (
    <>
      <DisabledModal
        handleClose={() => setisDisabledModalOpen(false)}
        isDisabledModalOpen={isDisabledModalOpen}
        disableFunction={handleDisable}
        disableTitle={'Onboarding'}
        disableName={getEntityName()}
      />
      <Group>
        <Button
          // variant="outline"
          onClick={() => update(isChecked[0])}
          disabled={disableU}
          data-cy='updateButton'
        >
          UPDATE
        </Button>
        <Button
          onClick={handleEnable}
          disabled={disableE}
          loading={isLoadingE}
          data-cy='enableButton'
        >
          ENABLE
        </Button>
        <Button
          // variant="outline"
          color='red'
          onClick={() => setisDisabledModalOpen(true)}
          loading={isLoadingD}
          disabled={disableD}
          data-cy='disableButton'
        >
          DISABLE
        </Button>
      </Group>
    </>
  );
}

export default UpdateDisableButton;
